import React from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../context-api/nav-context";
/* import honeywell from "../Assets/Images/boilerPage/honeywell.jpg"; */

const ContentLeft = ({ data }) => {
  const { contLeftTitle, contLeftText, leftImgUrl } = data[2];
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="boiler-extras section-wrapper"
      onMouseOver={closeNavbarMenu}
    >
      <div className="boiler-extras-text">
        <h1 className="title">{contLeftTitle}</h1>
        <p className="subtitle boiler-margin">{contLeftText}</p>
        <Link to="/quotes" className="btn-hero btn-quote">
          Find A Boiler
        </Link>
      </div>
      <div className="boilers-extras-img">
        <div className="img-container">
          <img src={leftImgUrl} alt="boiler extras" />
        </div>
      </div>
    </section>
  );
};

export default ContentLeft;
